import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { UrlApiEnvasado } from "../../../../services/apirest";

// ICONOS
import CircularProgress from "@mui/material/CircularProgress";

export default function StackedAreas(props) {
  const [loading, setLoading] = useState(true);
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const [chartData, setChartData] = useState([]);

  // Obtener el año y mes actuales
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // Inicializar con el año y mes actuales
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());

  // ***************************************************************

  // GETS DE LOS DATOS PARA EL CHART
  const obtenerDatosGrafico = async () => {
    setLoading(true);
    try {
      // Construir la URL base hasta el año seleccionado
      let url = `${UrlApiEnvasado}/envasado/fac_reng/pesototalvendido/anio/${selectedYear}`;
      // let url = `${UrlApiEnvasado}/envasado/fac_reng/pesototalvendido/anio/${2023}`;

      // Array para almacenar las partes adicionales de la URL
      const partesUrl = [];

      // Agregar parte fija "sucursal/" a la URL
      partesUrl.push(`sucursal`);

      // Agregar parte fija "chofer/" a la URL
      partesUrl.push(`chofer`);

      // Agregar parte fija "movil/" a la URL
      partesUrl.push(`movil`);

      // PROPANO BUTANO
      partesUrl.push(`probut`);

      // Agregar parte fija "peso/" a la URL
      partesUrl.push(`peso`);

      // Agregar parte fija "envase/" a la URL
      partesUrl.push(`envase`);

      // Agregar las partes acumuladas a la URL base
      if (partesUrl.length > 0) {
        url += `/${partesUrl.join("/")}`;
      }

      // Realizar la solicitud HTTP
      const response = await fetch(url);
      const data = await response.json();

      // Crear un conjunto completo de datos para todos los meses del año
      const mesesCompletos = Array.from({ length: 12 }, (_, i) => i + 1);

      // Transformación de datos
      const formattedData = mesesCompletos.map((mes) => {
        const item = data.find((d) => d.mes === mes);
        return {
          anio: selectedYear,
          mes,
          peso_total_vendido: item
            ? parseFloat(
                item.peso_total_vendido.replace(/\./g, "").replace(",", ".")
              )
            : 0,
        };
      });

      // Actualizar el estado con los datos formateados
      setChartData(formattedData);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener datos del gráfico:", error);
      setLoading(false);
    }
  };

  // En el componente del gráfico, filtrar los datos para los meses disponibles
  const mesesDisponibles = chartData.map((item) => item.mes);
  const seriesData = chartData
    .filter((item) => mesesDisponibles.includes(item.mes))
    .map((item) => item.peso_total_vendido);

  useEffect(() => {
    obtenerDatosGrafico();
    console.log("EJECUTO OBTENER DEL GRAFICO");
  }, []);

  console.log("Datos Deudores:", chartData);

  const series = [
    {
      data: seriesData,
      label: "kg Vendidos",
    },
  ];

  // ***************************************************************

  const formatYAxis = (value) => {
    // Formatea números mayores o iguales a 1 millón
    if (value >= 1e6) {
      return `${(value / 1e6).toLocaleString(undefined, {
        maximumFractionDigits: 1,
      })}M`;
    }
    // Formatea números mayores o iguales a 1 mil
    if (value >= 1e3) {
      return `${(value / 1e3).toLocaleString(undefined, {
        maximumFractionDigits: 1,
      })}k`;
    }
    // Para valores menores a 1000
    return value.toLocaleString();
  };

  return (
    <>
      <div
        style={{
          height: "100%", // Ocupa el 100% del espacio disponible
          width: "100%", // Ocupa el 100% del ancho
          position: "relative", // Para posicionar el loader correctamente
        }}
      >
        {loading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress size={60} />
          </div>
        ) : (
          <>
            {chartData.length > 0 ? (
              <div
                style={{
                  height: "calc(100% - 40px)", // Resta el espacio del título
                  width: "100%",
                  // marginTop: "10px",
                  position: "relative",
                  padding: "8px",
                }}
              >
                {/* Renderizar el gráfico mensual */}
                <BarChart
                  xAxis={[
                    {
                      id: "Mes",
                      data: meses,
                      scaleType: "band",
                      sx: { fontSize: "0.75rem" },
                    },
                  ]}
                  yAxis={[
                    {
                      valueFormatter: (value) =>
                        new Intl.NumberFormat("es-AR", {
                          notation: "compact",
                          compactDisplay: "short",
                          maximumFractionDigits: 1,
                        }).format(value),
                      sx: { fontSize: "0.75rem" },
                    },
                  ]}
                  series={series}
                  slotProps={{
                    legend: {
                      direction: "row",
                      position: { vertical: "top", horizontal: "middle" },
                      itemMarkWidth: 10,
                      itemMarkHeight: 6,
                      markGap: 2,
                      itemGap: 5,
                      labelStyle: { fontSize: "0.8rem" },
                    },
                  }}
                  margin={{ left: 60, right: 20, top: 40, bottom: 30 }}
                  style={{
                    height: "100%",
                    width: "100%",
                    minHeight: "200px",
                  }}
                  sx={{
                    "& .MuiChartsAxis-tickLabel": {
                      fontSize: "0.7rem", // Tamaño de fuente para todos los ticks
                    },
                    "& .MuiChartsAxis-directionY": {
                      transform: "translate(50px, 0)", // Más espacio para etiquetas largas
                    },
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                }}
              >
                <b>No hay datos disponibles para mostrar la gráfica.</b>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
